var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4849 27.3462C20.3928 27.3462 21.9394 25.8739 21.9394 24.0577C21.9394 22.2415 20.3928 20.7692 18.4849 20.7692C16.577 20.7692 15.0303 22.2415 15.0303 24.0577C15.0303 25.8739 16.577 27.3462 18.4849 27.3462ZM18.4849 27.3462C15.7384 27.3462 13.423 29.1027 12.7107 31.5M18.4849 27.3462C21.2313 27.3462 23.5467 29.1027 24.259 31.5M18.4849 12.8077C20.8948 12.8077 22.8485 10.948 22.8485 8.65385C22.8485 6.35974 20.8948 4.5 18.4849 4.5C16.0749 4.5 14.1212 6.35974 14.1212 8.65385C14.1212 10.948 16.0749 12.8077 18.4849 12.8077ZM18.4849 12.8077C15.4624 12.8077 12.8576 14.5096 11.6701 16.9615M18.4849 12.8077C21.5073 12.8077 24.1121 14.5096 25.2996 16.9615M8.8485 31.5H28.4849C29.6898 31.5 30.6667 30.5701 30.6667 29.4231V19.0385C30.6667 17.8914 29.6898 16.9615 28.4849 16.9615H8.8485C7.64351 16.9615 6.66668 17.8914 6.66668 19.0385V29.4231C6.66668 30.5701 7.64351 31.5 8.8485 31.5Z",
    stroke: "#0F90FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.f49904b99a92f82355ce6a60562f5319.svg";
export { ForwardRef as ReactComponent };